import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import { timeIntervalTypeOptions } from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';
import { defaultFormValues } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';

export interface TimeIntervalSegmentedControlProps {
  name: string;
  id: string;
  disabled?: boolean;
}

export function TimeIntervalSegmentedControl({
  name,
  id,
  disabled,
}: TimeIntervalSegmentedControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookSegmentedControlWrapper
      width="100%"
      id={id}
      control={control}
      disabled={disabled}
      label="Only during specific hours"
      name={name}
      defaultValue={defaultFormValues.timeIntervalType}
      options={timeIntervalTypeOptions}
    />
  );
}
